/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { axios } from '~/util/http/axioshttp';
import { queryOptions } from '@tanstack/react-query';
import type { PatientDemographicsViewModel } from './PatientDemographicsViewModel'; 

export function getPatientDemographicsOptions(stayId: string, onSuccess?: (result: PatientDemographicsViewModel) => void) {
	return queryOptions({
		queryKey: ['patient-demographics', stayId],
		queryFn: async () => {
			const url = '/_api/v1/homehealth/demographics/demographics/queries/getpatientdemographics/' + stayId;
			const resp = await axios.get<PatientDemographicsViewModel>(url);
			if(onSuccess) {
				onSuccess(resp.data);
			}
			return resp.data;
		},
        enabled: Boolean(stayId)
	});
}